module.exports = __webpack_public_path__ + "img/20191024172515360截图20191024162304695.84e93ca0.jpg";